module.exports = "<v-layout column wrap class=\"ml-3\">\n  <detail-header></detail-header>\n  <router-view name=\"childHeader\"></router-view>\n  <router-view name=\"content\"></router-view>\n</v-layout>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/block/block-child-detail/template.html
// module id = Zkn5
// module chunks = 0